import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { MAIN_ID } from '~/components/SkipLink'
import { Button } from '~/components/ui/button'

function Denied() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <main id={MAIN_ID} className="flex h-dvh w-full flex-col items-center justify-center gap-6 bg-background">
      <h1 className="text-lg font-bold text-foreground">
        {t('access.denied.message')}
      </h1>
      <Button
        variant="default"
        onClick={() => navigate('/')}
      >
        {t('common.back')}
      </Button>
    </main>
  )
}

export default Denied
